import { RouteComponentProps } from 'react-router-dom';

export interface IProps extends RouteComponentProps<any> {}

export interface IPreferences {
  screenName: String;
  referralCode: String;
  profilePic: string;
  bio: String;
}

export interface IExperience {
  practices_year: String;
  total_clear_aligner_cases: String;
  topics?: any;
}

export interface IPersonalDetails {
  firstName: String;
  lastName: String;
  password: String;
  dob: Date;
  email: String;
  mobile: IMobile;
  gdcNumber: String;
  dentalSchool: String;
  dentalSchoolName?: String;
}

export interface IMobile {
  ext: String;
  number: String;
}

export interface IAddress {
  address?: String;
  formattedAddress?: String;
  country?: String;
  city?: String;
  state?: String;
  zipCode?: String | null;
  postCode?: String | null;
  latitude?: Number;
  longitude?: Number;
}

export interface IPersonalDetailsComponentProps {
  initialValues?: IPersonalDetails;
  submittedValues: Function;
}

export interface IDesignerPersonalDetails {
  firstName: String;
  lastName: String;
  email: String;
  labName: String;
  mobile: IMobile;
  address: IAddress;
}

export interface IBankAccountDetails {
  bankName: String;
  bankCountry: String;
  accountHolderName: String;
  accountNumber: String;
  sortCode: String;
  iban: String;
  profilePic: string;
}

export interface ISpecialistPersonalDetails {
  firstName: String;
  lastName: String;
  email: String;
  // labName: String,
  mobile: IMobile;
  address: String;
  postcode: String;
  country: String;
}

export interface ISpecialistAccountDetails {
  bankName: String;
  bankCountry: String;
  accountHolderName: String;
  accountNumber: String;
  sortCode: String;
  iban: String;
}

export const YESNO = [
  {
    label: 'Yes',
    value: 'Yes',
  },
  {
    label: 'No',
    value: 'No',
  },
];
